import type { HTMLAttributes } from 'react';

import { cn } from './cn';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

const toneStyles: Record<BadgeTone, string> = {
  neutral: 'bg-cream-200 text-ink-700',
  success: 'bg-leaf/15 text-leaf',
  warning: 'bg-sun-500/15 text-sun-600',
  danger: 'bg-heart/15 text-heart',
  brand: 'bg-burgundy-500/10 text-burgundy-600',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
}

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider',
        toneStyles[tone],
        className,
      )}
      {...rest}
    />
  );
}
